import React from 'react';
import { useLocation } from 'react-router-dom';
import { useStyles } from '@/app/pages/confirmAccount/Themable.hooks';

export const ConfirmAccountExternalPage = () => {
    const location = useLocation();
    const classes = useStyles();
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const login = params.get('login');

    const iframeSrc = `/embed/account/confirm${token || login ? '?' : ''}${
        token ? `token=${encodeURIComponent(token)}` : ''
    }${token && login ? '&' : ''}${
        login ? `login=${encodeURIComponent(login)}` : ''
    }`;

    return (
        <div className={classes.root}>
            <iframe style={{ width: '100%', height: '100%' }} src={iframeSrc} />
        </div>
    );
};
